<template>
  <div class="maintop" id="main">
    <nav
      v-show="listfullscreen"
      :class="{ 'nav-back': delback, 'nav-back1': allback }"
    >
      <div style="height: 17px; width: 100vw"></div>
      <div class="u-flex" style="height: 43.68px">
        <div
          class="nav-title"
          style="position: relative"
          :class="{
            'nav-title-min': menuSlide == 'min' || menuSlide == 'mini',
          }"
        >
          <CSerch :delback="delback" :allback="allback" />
          <!--  -->
          <div v-if="page == 1" class="mode-login" style="left: 77px">
            <img class="left-img" src="../assets/images/meierch.png" />
            <div class="right-m">
              <div class="right-top">
                <p>全局搜索</p>
                <p>可通过关键词搜索润滑点</p>
              </div>
              <div class="right-bottom">
                <div class="botom close" @click="ok(-1)">关闭</div>
                <div class="botom btn" @click="ok(2)">我知道了</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="nav-title" :class="{'nav-title-min':menuSlide=='min'||menuSlide=='mini'}">{{title}} </div> -->
        <div class="loginp-msg">
          <!-- 页面标题 -->

          <!-- search -->

          <!-- 搜索 -->
          <!-- <div class="tix gz fl" @click="searchGlobal">

            <img v-if="delback" width="29px" height="31px" class='itix' style="width: 30px;height: 30px;" src="@/assets/images/icon-serach.png">
            <img v-else width="28px" height="31px" class='itix' style="width: 30px;height: 30px;" src="@/assets/images/icon-serach1.png">
          </div> -->

          <!-- 诊断报告 -->
          <div
            class="tix bell fl flex"
            @click="news(1)"
            style="margin-right: 0"
          >
            <div class="toopHeight u-flex">
              <Tooltip content="诊断报告" theme="light" style="height: 30px">
                <img
                  class="itix"
                  style="width: 30px; height: 30px"
                  src="@/assets/images/zdbg.png"
                />
              </Tooltip>
            </div>
            <span class="num" v-if="queNum" style="left: 28px; top: 11px">{{
              queNum
            }}</span>
          </div>

          <!-- 盖章 -->

          <div
            class="tix gz fl"
            @click="users"
            v-if="
              ['customer_administrator', 'agency_administrator'].indexOf(
                userRole
              ) > -1
            "
          >
            <div class="toopHeight u-flex">
              <Tooltip content="注册审批" theme="light">
                <img
                  style="width: 30px; height: 30px"
                  class="itix"
                  src="@/assets/images/icon-gz.png"
                />
              </Tooltip>
              <span class="num" v-if="userNum" style="left: 30px">{{
                userNum
              }}</span>
            </div>
          </div>

          <!-- 消息 -->
          <div
            class="tix bell fl u-rel"
            :class="{ rmessage: vmseeage }"
            id="message"
            @click="news(0)"
          >
            <div class="toopHeight u-flex">
              <Tooltip content="消息和公告" theme="light">
                <img class="itix" src="@/assets/images/icon-bell.png" />
              </Tooltip>
              <span class="num" v-if="newsnum">{{ newsnum }}</span>
              <div class="modl">
                <messagePopup @systemnew="sysnew" />
              </div>
            </div>
            <div class="mode-login" v-if="page == 3">
              <img class="left-img" src="../assets/images/zwtz.png" />
              <div class="right-m">
                <div class="right-top">
                  <p>点击查看系统消息</p>
                </div>
                <div class="right-bottom">
                  <div class="botom close" @click.stop="ok(-1)">关闭</div>
                  <div class="botom btn" @click.stop="ok(-1)">我知道了</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 用户头像 -->
          <!-- <div class="avatar fl">
                    <img src="@/assets/images/avatar.png" alt="">
                </div> -->
          <Dropdown trigger="click" :transfer="true">
            <!-- <p class="role-type" v-if="isDev && roleName">{{roleName}}</p> -->
            <a class="anchorPoint-userinfo" href="javascript:void(0)">
              {{ userinfo1.monicker || userinfo1.nickname || "-" }}
              <!-- <Icon type="md-arrow-dropdown" /> -->
              <img
                style="width: 16px; height: 18px; vertical-align: middle"
                src="@/assets/images/arr-bottom.png"
                alt=""
              />
            </a>
            <DropdownMenu class="dwmentu-width" slot="list">
              <div class="gs line-2">
                <div><img src="@/assets/images/company.png" alt="" /></div>
                <div class="text">
                  <span class="topspan"> {{ userinfo1.companyName }}</span>
                </div>
              </div>
              <div class="edition">
                <img
                  style="width: 24px; height: 24px; vertical-align: middle"
                  src="@/assets/images/user.png"
                  alt=""
                />
                <span class="topspan"> {{ roleName }}</span>
              </div>
              <a href="javascript:;" @click="modPsdPop">
                <DropdownItem name="modpsd"
                  ><img
                    style="
                      width: 24px;
                      height: 24px;
                      vertical-align: middle;
                      margin-right: 5px;
                    "
                    src="@/assets/images/secret.png"
                    alt=""
                  />
                  <span class="topspan">隐私政策</span>
                </DropdownItem>
              </a>
              <a href="javascript:;" @click="agreement">
                <DropdownItem name="modpsd">
                  <img
                    style="
                      width: 24px;
                      height: 24px;
                      vertical-align: middle;
                      margin-right: 5px;
                    "
                    src="@/assets/images/file.png"
                    alt=""
                  />

                  <span class="topspan">用户协议</span>
                </DropdownItem>
              </a>
              <!-- <DropdownItem name='avatar'>上传头像</DropdownItem> -->
              <div class="edition ivu-dropdown-item" @click="version()">
                <img
                  style="
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin-right: 5px;
                  "
                  src="@/assets/images/edition.png"
                  alt=""
                />

                <span class="topspan" style="left: -3px">
                  {{ versionmsg }}</span
                >
              </div>
              <a class="anchorPoint-logout" href="javascript:;" @click="logout">
                <DropdownItem name="modpsd"
                  ><img
                    style="
                      width: 24px;
                      height: 24px;
                      vertical-align: middle;
                      margin-right: 5px;
                    "
                    src="@/assets/images/out.png"
                    alt=""
                  />
                  <span class="topspan">退出登录</span>
                </DropdownItem>
              </a>
            </DropdownMenu>
            <div class="mode-login" v-if="page == 0">
              <img class="left-img" src="../assets/images/zwtz.png" />
              <div class="right-m">
                <div class="right-top">
                  <p>点击个人中心可查看用户协议，版本号或者退出登录</p>
                </div>
                <div class="right-bottom">
                  <div class="botom close" @click.stop="ok(-1)">关闭</div>
                  <div class="botom btn" @click.stop="ok(1)">我知道了</div>
                </div>
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
    </nav>
    <div class="allWrap" id="allWrap">
      <Allmenu :curPath="curPath" :screenWidth="screenWidth" />
      <div
        class="content"
        id="allContent"
        :class="{
          allback: allback,
          allbackdetion: delback,
          padd0: listfullscreen == false,
        }"
      >
       <!-- allback: allback -->
        <div
          class="rightContent"
          :class="{ 'h-full': isFullscreen, }"
          id="rightContent"
        >
          <!--'padd0':-->
          <!-- <keep-alive></keep-alive>   -->
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
          <Spin size="large" fix v-if="$store.state.spinShow"></Spin>
        </div>
      </div>
    </div>

    <Modal
      v-model="warningPop"
      class="warningPop newModal"
      width="360"
      :mask-closable="false"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="md-alert" style="font-size: 20px" />&nbsp;
        <span style="font-size: 18px">报警提示</span>
      </p>
      <div style="font-size: 16px; text-align: center">
        <p style="padding: 15px 0">
          润滑点"<strong>模拟的润滑点</strong>"正在报警!
        </p>
        <p style="font-size: 14px; color: #999">
          温度（最高25度）超过上限，水分（最高20%）超过上上限,
          温度（最高25度）超过上限
        </p>
      </div>
      <div slot="footer" style="text-align: center">
        <Button style="width: 100px" @click="closeWarningPop">忽略</Button
        >&nbsp;&nbsp;
        <Button style="width: 100px" type="primary" @click="toRhDetail"
          >详情</Button
        >
      </div>
    </Modal>
    <div v-if="showModal">
      <UseragreementModal
        ref="useragreementModal"
        :curItemDetails="curItemDetails"
        @on-close-cancel="onCloseCancel"
      ></UseragreementModal>
    </div>

    <div class="vModal" v-if="vModal">
      <MainVersionModal
        ref="versionModal"
        :showvModal="vModal"
        @close="vModalClose"
      ></MainVersionModal>
    </div>
    <ctoast ref="toast" />
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import "@/assets/css/reset.css";
import "@/assets/css/index.less";
import Allmenu from "@/components/Menu.vue";
import MainVersionModal from "../views/system/components/mainVersion-modal.vue";
import UseragreementModal from "../views/system/components/useragreement-modal.vue";
import CSerch from "@/components/c-serch/index";
import messagePopup from "@/components/messagePopup/index";

import { notmove } from "@/api/pubrequst.js";
import ctoast from "@/components/c-toast/index";
import Base64 from "@/util/encryptlong";
import { mapState } from "vuex";
import { setUserInfo } from "@/util";

export default {
  name: "main1",
  data() {
    return {
      equmenunum: 0,
      isDev: process.env.NODE_ENV === "development",
      screenWidth: document.body.clientWidth,
      curPath: this.$route.path || "/index",
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      userRole: null,
      roleUser: ls.get("userRole") || "",
      roleName: null,
      keyword: null,
      showModal: false,
      warningPop: false,
      warningTimer: null,
      historyItems: ls.get("searchHistory") || [],
      recommendItems: ["风机", "盾构机", "齿轮箱", "液压系统"],
      isclearHis: false,
      userinfo1: {},
      allback: false,
      delback: false,
      vModal: false,
      vmseeage: true,
      cmlist: [],
      isFullscreen: false,
    };
  },
  computed: {
    ...mapState({
      articles: (state) => {
        return state.articles;
      },
      title: (state) => {
        return state.pub.title;
      },
      menuSlide: (state) => {
        return state.pub.menuSlide;
      },
    }),
    uRights() {
      return this.$store.state.userRights;
    },
    newsnum() {
      return this.formatNumber(this.$store.state.newsNum);
    },
    userNum() {
      return this.$store.state.userNum;
    },
    listfullscreen() {
      return this.$store.state.fullsreeen;
    },
    page() {
      //是否出现新手指导
      return this.$store.state.page;
    },
    queNum() {
      return this.formatNumber(this.$store.state.queNum);
    },
    versionmsg() {
      return this.$store.state.pub.versionmsg;
    },
  },
  components: {
    Allmenu,
    UseragreementModal,
    MainVersionModal,
    CSerch,
    messagePopup,
    ctoast,
  },
  created() {
  },
  mounted: async function () {
    this.init();
    // 监听浏览器宽度
    const that = this;
    window.addEventListener("resize", this.onResizeChange);

    if (this.getBrowserInfo().browser != "chrome") {
      alert("推荐使用Chrome浏览器操作本系统 体验更佳噢");
    }
    document.addEventListener("fullscreenchange", this.onFullscreenChange);
    this.setpage();
  },
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.onFullscreenChange);
    window.removeEventListener("resize", this.onResizeChange);
  },
  methods: {
    onResizeChange() {
      let that=this
      return (() => {
        that.screenWidth = document.body.clientWidth;
      })();
    },
    onFullscreenChange() {
      let isFullscreen = document.fullscreenElement != null;
      console.log("Is fullscreen:", isFullscreen);
      this.isFullscreen = isFullscreen;
      // 在这里你可以根据 isFullscreen 的值来更新你的组件的状态或者执行其他的操作
    },
    sysnew() {
      this.vmseeage = false;
      let t = setTimeout(() => {
        clearTimeout(t);
        this.vmseeage = true;
      }, 2000);
    },
    vModalClose() {
      this.vModal = false;
    },
    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(0) + "k";
      } else {
        return Number(num);
      }
    },
    ok(page) {
      this.$store.commit("setpage", page);
    },
    setpage() {
      if (this.userInfo.isOneLogin) {
        const { isOneLogin } = this.userInfo;
        let obj = this.userInfo;
        obj.isOneLogin = false;
        let userInfoStr = Base64.encode(JSON.stringify(obj));
        ls.page("userInfo", userInfoStr);
        if (isOneLogin) {
          this.$store.commit("setpage", 0);
        }
      }
    },

    logout() {
      api.axs("delete", "/ocm-auth/oauth/logout").then((res) => {
        if (res.code === "00000") {
          window.location.reload();
        }
      });
      ls.page('userInfo', '');
      ls.clearAll();
      notmove(2);
      if (this.roleUser.indexOf("m") > -1) this.$router.push("/admin/login");
      else this.$router.push("/customer/login");
    },
    findNewElement(a, b) {
      const newElements = [];
      // 遍历数组 b
      for (const element of b) {
        // 如果元素不在数组 a 中，将其添加到新元素数组中
        if (!a.includes(element)) {
          newElements.push(element);
        }
      }

      return newElements;
    },
    async init() {
      this.userRole = this.userInfo.authority;
      if (this.userRole) {
        switch (this.userRole) {
          case "mobil_user":
            this.roleName = "美孚•普通用户";
            break;
          case "mobil_administrator":
            this.roleName = "美孚•管理员";
            break;
          case "customer_user":
            this.roleName = "客户•普通用户";
            break;
          case "customer_administrator":
            this.roleName = "客户•管理员";
            break;
          case "agency_user":
            this.roleName = "经销商•普通用户";
            break;
          case "agency_administrator":
            this.roleName = "经销商•管理员";
            break;
          case "mobil_user_safety_auditor":
            this.roleName = "安全审计员";
            break;
          case "mobil_user_security_administrator":
            this.roleName = "安全管理员";
            break;
        }
      }
      this.$store.dispatch("pub/SET_TITLE", this.$route.meta.title);
      api.axs("post", `/ocm-admin/user/userInfo`).then(({ data }) => {
        if (!data) {
          // data.companyName = "埃克森美孚公司";
          data = {
            companyName: "埃克森美孚公司",
          };
        }
        this.userinfo1 = data;
      });
      // this.$store.dispatch("pub/GET_PULL_DATA");
      this.$store.dispatch("pub/SET_VERSION");
      this.$store.dispatch("pub/SET_SCOK_DATA");
      this.$store.dispatch("newsNum");
      this.$store.dispatch("userNum");
      this.$store.dispatch("setqueNum");
      this.$nextTick(() => {
        let t1 = setTimeout(() => {
          if (this.articles.length > 0) {
            this.$refs["toast"].getItem();
          }
          clearTimeout(t1);
        }, 1500);
      });
      let t = setInterval(() => {
        this.$store.dispatch("userNum");
        this.$store.dispatch("newsNum");
      }, 1000 * 5);
    },
    agreement() {
      api
        .axs("get", `/ocm-admin/userAgreement/getPrivacyPolicy?type=${1}`)
        .then((res) => {
          if (res.code === "00000") {
            this.curItemDetails = res.data;
            ls.set("useitem", this.curItemDetails);
            const routeUrl = this.$router.resolve({
              path: `/system/agreement`,
            });

            window.open(routeUrl.href, "_blank");
            // this.showModal = true; routeUrl
            // this.$emit("on-open-modal");
          }
        });
    },
    modPsdPop() {
      api
        .axs("get", `/ocm-admin/userAgreement/getPrivacyPolicy?type=${0}`)
        .then((res) => {
          if (res.code === "00000") {
            this.curItemDetails = res.data;

            ls.set("useitem", this.curItemDetails);
            const routeUrl = this.$router.resolve({
              path: `/system/agreement`,
            });
            window.open(routeUrl.href, "_blank");
          }
        });
    },
    onCloseCancel(bool) {
      this.showModal = bool;
    },
    users() {
      this.$router.push("/system/register");
    },
    news(index = 0) {
      if (index == 0) {
        this.$router.push("/system/news");
      } else if (index == 1) {
        let url = this.$route.fullPath;
        if (url == "/warning/diagnostic") {
          this.$store.commit("diagnostic/setdiager");
          // this.$store.commit("pub/setmenuSlide", this.menuSlide)
        } else {
          this.$router.push("/warning/diagnostic");
        }
      }
    },
    toRhDetail() {
      //跳转报警润滑点
      this.$router.push(`/warning/record/1495933616334249985`);
      this.warningPop = false;
    },
    closeWarningPop() {
      this.warningPop = false;
      // 清除定时器
      clearInterval(this.warningTimer);
      this.warningTimer = null;
    },
    getBrowserInfo() {
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
      var m = ua.match(re);
      Sys.browser = m[1].replace(/version/, "'safari");
      Sys.ver = m[2];
      return Sys;
    },

    //埋点记录
    recordPath(np, op) {
      const datas = {
        type: 10,
        url:
          np && op
            ? "form: " + op.path + " to: " + np.path
            : "form: /login" + " to: /index",
      };

      api.axss("post", `/ocm-admin/clickRecord/save`, datas);
    },
    version() {
      this.vModal = true;
    },
  },

  watch: {
    // articles: {
    //   deep: true,
    //   immediate: true,
    //   handler: function (newvalue, oldvalue) {
    //     let arr;
    //      if(oldvalue==undefined){
    //        arr = newvalue;
    //      }else if(oldvalue.length==0){
    //          arr = newvalue;
    //      }else if(oldvalue.length>0){
    //       let newarr=newvalue.map(e=>e.messageContent)
    //        let oldarr=newvalue.map(e=>e.messageContent)
    //       arr = this.findNewElement(newarr, oldarr);
    //      }

    //      this.cmlist=arr

    //     if(arr.length>0){

    //       arr.forEach(e=>{
    //         this.$Message.info({
    //           onClose:(e1)=>{

    //             messageCentergetDetails(e.id)
    //             .then(()=>{
    //               this.$store.dispatch("newsNum");
    //             })
    //           },
    //           closable:true,
    //            duration: 1000*60*60*24,
    //            content:e.messageContent
    //             });

    //       })
    //     }
    //   },
    // },
    $route: {
      immediate: true,
      handler(np, op) {
        let path = this.$route.path;

        if (path == "/bulletin/detection") {
          this.delback = true;
          this.allback = false;
        } else if (path == "/operate/datas") {
          this.allback = true;
          this.delback = false;
        } else if (path != "/search") {
          //如果不是搜索页面 则清空搜索框
          this.keyword = "";
          this.allback = false;
          this.delback = false;
        } else {
          this.allback = false;
          this.delback = false;
        }
        this.curPath = this.$route.path;
        let allPaths = ls.get("allPaths") || [];
        if (
          (allPaths.length && allPaths[0] !== this.curPath) ||
          !allPaths.length
        )
          allPaths.unshift(this.curPath);
        ls.set("allPaths", allPaths);

        this.recordPath(np, op);
      },
    },
    screenWidth: {
      immediate: true,
      handler(newValue) {
        this.screenWidth = newValue;
      },
    },
  },
};
</script>
<style>
#main /deep/ .ivu-dropdown-item {
  min-width: 170px !important;
  width: 170px !important;
  /* border: 1px solid red !important; */
}

.ivu-dropdown-item:hover {
  color: #0c479d;
}
</style>
<style lang="less">
#main {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  // color: #2c3e50;
  .nav-back {
    background-color: #031027;
    background-image: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));

    .nav-title {
      color: #ffffff;
    }
  }

  .nav-back1 {
    background-color: #031027;
    background-image: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.8));

    .nav-title {
      color: #ffffff;
    }
  }

  nav {
    width: 100vw;

    position: fixed;

    padding-bottom: 10px;
    z-index: 101;

    align-items: center;

    line-height: 50px;
    font-size: 14px;
    background-color: #fff; //#495060;
    color: #fff;

    // box-shadow: 0 0 8px #ddd;
    .nav-title {
      position: relative;
      // left: 274px;
      left: 255px;
      color: #000000;
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.851);
    }

    .nav-title-min {
      left: 82px !important;
    }

    .logo {
      height: 34px;
      margin-left: 14px;
      margin-top: 7px;
      display: inline-block;
      vertical-align: middle;

      img {
        height: 100%;
      }
    }

    .sys-name {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      line-height: 49px;
      margin-left: 10px;
    }

    .loginp-msg {
      position: absolute;
      right: 14px;

      .global-search {
        position: relative;
        margin-right: 25px;

        .ivu-input-wrapper {
          .ivu-input-icon {
            font-size: 20px;
            padding-right: 4px;

            &:hover {
              color: #0c479d;
            }
          }

          .ivu-input {
            width: 300px;
            height: 34px;
            border: none;
            font-size: 13px;
            background-color: #f8f8f8;
            border-radius: 34px;
            padding: 4px 20px;
            padding-right: 35px; // 防止遮挡icon

            &::placeholder {
              font-size: 12px;
              font-weight: bold;
            }
          }
        }

        .searchValWrap {
          display: none;
          position: absolute;
          top: 60px;
          width: 300px;
          min-height: 100px;
          font-size: 12px;
          color: #444;
          padding: 10px 0;
          line-height: 20px;
          border: 1px solid #f2f2f2;
          border-top: none;
          box-shadow: 0 4px 6px #ddd;
          background-color: #fff;

          .seTitle {
            font-size: 13px;
            line-height: 20px;
            margin-bottom: 10px;
            padding: 0 20px;

            .ivu-icon-md-trash {
              font-size: 16px;
              color: #888;
              cursor: pointer;

              &:hover {
                color: #e65151;
              }
            }
          }

          .seTitle2 {
            margin-top: 15px;
          }

          .seItems {
            padding: 0 10px;

            & > span {
              display: inline-block;
              font-size: 12px;
              color: #888;
              padding: 1px 6px;
              margin: 6px 8px;
              border: 1px solid #ddd;
              cursor: pointer;
              box-shadow: 2px 2px 2px #f8f8f8;
            }
          }
        }
      }

      .role-type {
        position: absolute;
        top: 36px;
        right: 22px;
        width: 94px;
        text-align: center;
        line-height: 16px;
        border-radius: 4px;
        padding: 2px 4px 1px;
        font-size: 12px;
        color: #fff;
        background-color: #f5914f;
      }

      .message {
        position: relative;
        color: #999;
        font-size: 25px;
        margin: 14px 24px 0 10px;
        line-height: 20px;
        cursor: pointer;

        .nums {
          position: absolute;
          top: -8px;
          left: 16px;
          color: #da7329;
          font-size: 13px;
          font-weight: bold;
        }
      }

      .addNotice {
        position: relative;
        color: #2d97d4;
        font-size: 16px;
        margin: 16px 10px;
        line-height: 20px;
        cursor: pointer;

        span {
          display: inline-block;
          width: 21px;
          height: 21px;
          line-height: 19px;
          text-align: center;
          border-radius: 50%;
          border: 2px solid #2d97d4;
        }
      }

      .tix {
        position: relative;

        .itix {
          width: 16px;
          height: 21px;
          margin: 0 15px;
          vertical-align: middle;
          cursor: pointer;
        }
        img {
          transition: filter 0.3s ease; /* 添加过渡效果 */
        }
        .num1 {
          left: 28px !important;
        }

        .num {
          position: absolute;
          top: 12px;
          left: 24px;
          width: auto;
          height: 16px;
          line-height: 16px;
          font-size: 12px;
          padding: 0 5px;
          text-align: center;
          border-radius: 14px;
          color: #fff;
          background-color: #f03c3c;
          cursor: pointer;
        }

        &.gz {
          .itix {
            width: 18px;
            height: 21px;
          }
        }

        &.bell {
          margin-right: 20px;
        }
        &:hover {
          filter: brightness(1.1); /* 改变亮度，使图像高亮 */
        }
      }

      .hasmes {
        color: #3e9def;
      }

      .avatar {
        width: 36px;
        height: 36px;
        margin-top: 8px;
        margin-right: 10px;
        border-radius: 50%;
        border: 1px solid #ccc;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .ivu-dropdown-rel a {
        font-size: 16px;
        font-weight: 500;
        color: #666; //#ff944d;
      }
    }
  }

  .allback {
    background-image: url("../assets/images/blueback.png");
    background-size: 100% 100%;
    overflow-x: hidden !important;
  }

  .allbackdetion {
    background-color: #031027 !important;
    background-size: 100% 100%;
    padding-right: 0 !important;
    padding-bottom: 0 !important;

    .ivu-spin-fix {
      background: #031027;
    }
  }

  .allWrap {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    //    ::-webkit-scrollbar {

    //   display: none;
    //   /* Chrome Safari */
    // }

    .content {
      // min-width: 1350px;
      // min-width:1200px;
      position: relative;
      flex: 2;
      font-size: 14px;
      padding: 20px;
      padding-top: 70px;
      padding-bottom: 0 !important;
      padding-left: 24px;
      padding-right: 0;

      background-color: #fff;
      overflow-x: auto;
      overflow-y: hidden;

      .top-title {
        color: #222;
        font-size: 22px;
        margin-bottom: 8px;

        & > .ivu-icon {
          font-size: 24px;
          padding-right: 4px;
          cursor: pointer;
        }
      }
    }
  }
}

.warningPop {
  font-size: 16px;
}

.ani_swing {
  //摇晃
  animation: Swing 1.3s ease-in-out infinite;
  transform-origin: 100% 100%;
  transform: rotate(-8deg);
}

@keyframes Swing {
  0% {
    transform: rotate(-5deg);
  }

  50% {
    transform: rotate(5deg);
  }

  100% {
    transform: rotate(-5deg);
  }
}

.shake {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.18);
  }

  100% {
    transform: scale(1);
  }
}

.dwmentu-width {
  width: 170px !important;
  min-width: 170px !important;

  a {
    text-align: center;
    font-size: 12px !important;

    font-weight: 500 !important;
    color: rgba(0, 0, 0, 0.8509803921568627) !important;
  }
}

.ivu-select-dropdown {
  padding: 0 !important;
  max-height: 300px !important;
}

.gs {
  display: flex !important;
  // flex-direction: column;
  width: 170px;
  // max-height: 48px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.35);
  padding: 8px 16px;

  // border-bottom: 1px solid #dddbdb;
  img {
    text-align: center;
    height: 24px;
    width: 24px;
    margin-right: 5px;
    vertical-align: middle;
  }

  // .text {
  //     overflow: hidden !important;
  //     word-break: break-all !important;
  //     text-overflow: ellipsis !important;
  //     -webkit-box-orient: vertical !important;
  // }
}

.edition {
  border-top: 1px solid #dddbdb;
  width: 170px;
  font-weight: 400;
  padding: 8px 16px;
  font-size: 14px;
  border-bottom: 1px solid #dddbdb;
  line-height: 14px;
}

.ivu-dropdown-item {
  text-align: left !important;
}

.topspan {
  position: relative;
  top: 2px;
}

.padd0 {
  padding-top: 0 !important;
  overflow: hidden !important;
}

.mode-login {
  width: 307px;
  height: 109px;
  background-image: url("../assets/images/mode-img.png");
  background-size: 100% 100%;
  top: 3px;
  left: -305px;
  position: absolute;
  padding: 14px 14px 12px 18px;
  display: flex;
  z-index: 1000;

  .left-img {
    width: 91px;
    height: 83px;
  }

  .right-m {
    width: 132px;
    margin-left: 23px;
    position: relative;
  }

  .right-top {
    font-size: 12px;

    font-weight: 500;
    color: #000000;

    p {
      height: 16px;
      line-height: 16px;
    }
  }

  .right-bottom {
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 26px;
    color: #000000;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn {
      width: 80px;
      height: 26px !important;
      background: #0c479d;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      line-height: 26px !important;
      font-size: 12px;

      font-weight: 400;
      color: #ffffff;
      text-align: center;
      position: relative;
      left: 10px;
      cursor: pointer;
    }

    .botom {
      // height: 26px !;
      // line-height: 17px !important;
    }

    .close {
      text-decoration: underline;
      font-size: 12px;

      font-weight: 400;
      color: #6d7582;
      cursor: pointer;
    }
  }
}
.modl {
  display: none;
  // display: block;
}
.rmessage {
  &:hover {
    .modl {
      display: block;
    }
  }
}

.tab-title {
  margin-bottom: 14px !important;
}
.toopHeight {
  line-height: 1;
  height: 51px;
}
.allbackbg0 {
  background-color: rgb(0, 0, 0) !important;
 
}
</style>